import script from "./TaxRateRemote.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaxRateRemote.vue?vue&type=script&setup=true&lang=ts"

import "./TaxRateRemote.vue?vue&type=style&index=0&id=cbbe2e90&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbbe2e90"]])

export default __exports__